function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import Common from "../components/includes/Common";
import moment from "moment";
import { DatePicker, Space, Table, message, Button, Divider, Form, Tabs, Modal, List, notification } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import { Excel } from "antd-table-saveas-excel";
import { Download, Cash, CheckCircleFill, BuildingFillGear, XCircleFill, PencilSquare } from "react-bootstrap-icons";
import CompanyBills from "../components/CompanyBills";
import InsBills from "../components/InsBills";
import Moment from "react-moment";
import UserBills from "../components/UserBills";
import dayjs from 'dayjs';
import Autorisations from "../components/Autorisations";
import AddExpenseCategory from "./forms/AddExpenseCategory";
import EditExpenseCategory from "./forms/EditExpenseCategory";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var TabPane = Tabs.TabPane;

var Expenses = function Expenses() {
  var _Modal$useModal = Modal.useModal(),
      _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
      confirm = _Modal$useModal2[0].confirm,
      contextHolder = _Modal$useModal2[1];

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      listOfBills = _useState2[0],
      setListOfBills = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      expenses = _useState4[0],
      setExpenses = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      expensesAr = _useState6[0],
      setExpensesAr = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      billsArrayData = _useState8[0],
      setBillsArrayData = _useState8[1];

  var _useState9 = useState(true),
      _useState10 = _slicedToArray(_useState9, 2),
      isDataLoading = _useState10[0],
      setIsDataLoading = _useState10[1];

  var _useState11 = useState(moment().startOf('month').format()),
      _useState12 = _slicedToArray(_useState11, 2),
      from = _useState12[0],
      setFrom = _useState12[1];

  var _useState13 = useState(moment().endOf('month').format()),
      _useState14 = _slicedToArray(_useState13, 2),
      to = _useState14[0],
      setTo = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      dataChanged = _useState16[0],
      setDataChanged = _useState16[1];

  var _useState17 = useState(null),
      _useState18 = _slicedToArray(_useState17, 2),
      selectedExpense = _useState18[0],
      setSelectedExpense = _useState18[1];

  var _useState19 = useState([]),
      _useState20 = _slicedToArray(_useState19, 2),
      expenseCategories = _useState20[0],
      setExpenseCategories = _useState20[1];

  var _useState21 = useState(null),
      _useState22 = _slicedToArray(_useState21, 2),
      selectedCategory = _useState22[0],
      setSelectedCategory = _useState22[1];

  var _useState23 = useState(false),
      _useState24 = _slicedToArray(_useState23, 2),
      showEditCategory = _useState24[0],
      setShowEditCategory = _useState24[1];

  var rangePresets = {
    "Aujourdh'ui": [moment().startOf('day'), moment().endOf('day')],
    'Cette semaine': [moment().startOf('week'), moment().endOf('week')],
    'Ce mois': [moment().startOf('month'), moment().endOf('month')]
  };
  var cols = [{
    title: "Date",
    dataIndex: "date",
    render: function render(date) {
      return /*#__PURE__*/_jsx(Moment, {
        format: "DD/MM/YYYY HH:mm",
        date: date
      });
    },
    key: "date"
  }, {
    title: "Initiateur",
    dataIndex: "user",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "patient"
  }, {
    title: "Catégorie",
    dataIndex: "category",
    key: "category",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    }
  }, {
    title: "Montant (GNF)",
    dataIndex: "amount",
    key: "aount",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    }
  }, {
    title: "Motif",
    dataIndex: "comment",
    key: "comment",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    }
  }, {
    title: "Approuv./Rejeter",
    dataIndex: "action",
    key: "action",
    render: function render(t) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [t.status == 0 && /*#__PURE__*/_jsxs(Space, {
          direction: "horizontal",
          children: [contextHolder, /*#__PURE__*/_jsx(Button, {
            style: {
              color: "#34C482"
            },
            onClick: function onClick() {
              handleApproveExpense(t);
            },
            disabled: t.status == 1 || t.status == 2,
            children: /*#__PURE__*/_jsx("b", {
              children: /*#__PURE__*/_jsx(CheckCircleFill, {
                size: 25
              })
            })
          }), contextHolder, /*#__PURE__*/_jsx(Button, {
            style: {
              color: "#C46D4E"
            },
            onClick: function onClick() {
              handleRejectExpense(t);
            },
            disabled: t.status == 2 || t.status == 1,
            children: /*#__PURE__*/_jsx("b", {
              children: /*#__PURE__*/_jsx(XCircleFill, {
                size: 25
              })
            })
          })]
        }), t.status == 1 && /*#__PURE__*/_jsx(Space, {
          direction: "horizontal",
          children: /*#__PURE__*/_jsx(Button, {
            style: {
              color: "#34C482"
            },
            onClick: function onClick() {
              handleApproveExpense(t);
            },
            disabled: t.status == 1 || t.status == 2,
            children: /*#__PURE__*/_jsx("b", {
              children: /*#__PURE__*/_jsx(CheckCircleFill, {
                size: 25
              })
            })
          })
        }), t.status == 2 && /*#__PURE__*/_jsx(Space, {
          direction: "horizontal",
          children: /*#__PURE__*/_jsx(Button, {
            style: {
              color: "#C46D4E"
            },
            onClick: function onClick() {
              handleRejectExpense(t);
            },
            disabled: t.status == 2 || t.status == 1,
            children: /*#__PURE__*/_jsx("b", {
              children: /*#__PURE__*/_jsx(XCircleFill, {
                size: 25
              })
            })
          })
        })]
      });
    }
  }];

  var handleApproveExpense = function handleApproveExpense(t) {
    setSelectedExpense(t);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous l'approbation de la demande ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["Autoriser la sortie de ", t.amount.toLocaleString("Fr"), " GNF demand\xE9e par ", t.user.firstname, " ", t.user.lastname]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "approvetransaction", {
          cash_transaction_id: t.id.toString(),
          user_id: Common.currentUser.id
        }).then(function (response) {
          if (response.data.status == 200) {
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
          } else {
            notification.error({
              message: "Ok!",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Ok!",
            description: "Une erreur est survenue. Code: " + error.toString()
          });
        })["finally"](function () {});
      }
    });
  };

  var handleRejectExpense = function handleRejectExpense(t) {
    setSelectedExpense(t);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous le rejet de la demande ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["Sortie de ", t.amount.toLocaleString("Fr"), " GNF demand\xE9e par ", t.user.firstname, " ", t.user.lastname]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "rejecttransaction", {
          transaction_id: t.id.toString(),
          user_id: Common.currentUser.id
        }).then(function (response) {
          if (response.data.status == 200) {
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
          } else {
            notification.error({
              message: "Ok!",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Ok!",
            description: "Une erreur est survenue. Code: " + error.toString()
          });
        })["finally"](function () {});
      }
    });
  };

  var handleExport = function handleExport() {
    var excel = new Excel();
    excel.addSheet("sheet").addColumns(cols).addDataSource(billsArrayData, {
      str2Percent: true
    }).saveAs(from + "-" + to + ".xlsx");
  };

  var onSearchFinish = function onSearchFinish(values) {
    setListOfBills([]);
    setBillsArrayData([]);
    setFrom(moment(new Date(values.range[0]._d)).format());
    setTo(moment(new Date(values.range[1]._d)).format());
  };

  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + "getexpenses/" + moment(new Date(from)).format() + "/" + moment(new Date(to)).format() + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setExpensesAr([]);
        setExpenses(response.data.expenses);
        response.data.expenses.forEach(function (e) {
          setExpensesAr(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: e.id,
              category: e.expense_category.label,
              status: e.status,
              date: e.created_at,
              user: e.user.firstname + " " + e.user.lastname,
              amount: e.amount.toLocaleString("Fr"),
              comment: e.comment,
              action: e
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [from, to, dataChanged]);
  useEffect(function () {
    setIsDataLoading(true);
    setDataChanged(false);
    axios.get(Common.baseApiUrl + "getexepensecategories/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setExpenseCategories([]);
        setExpenseCategories(response.data.categories);
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [dataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsxs(Col, {
          lg: 8,
          md: 8,
          sm: 12,
          children: [/*#__PURE__*/_jsx(Form, {
            size: "large",
            onFinish: onSearchFinish,
            layout: "horizontal",
            children: /*#__PURE__*/_jsxs(Space, {
              direction: "horizontal",
              children: [/*#__PURE__*/_jsx(Form.Item, {
                name: "range",
                rules: [{
                  required: true,
                  message: "Champs obligatoire"
                }],
                children: /*#__PURE__*/_jsx(RangePicker, {
                  ranges: rangePresets,
                  showTime: {
                    format: 'HH:mm'
                  },
                  format: "DD-MM-YYYY HH:mm"
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  htmlType: "submit",
                  children: /*#__PURE__*/_jsx("b", {
                    children: "RECHERCHE"
                  })
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  onClick: handleExport,
                  style: {
                    background: "#34C482"
                  },
                  icon: /*#__PURE__*/_jsx(Download, {
                    size: 28
                  }),
                  children: /*#__PURE__*/_jsx("b", {
                    children: "EXPORTER"
                  })
                })
              })]
            })
          }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs("div", {
            style: {
              fontWeight: "bold",
              fontStyle: 'italic'
            },
            children: ["Du ", new Date(from).toLocaleDateString("Fr"), " Au ", new Date(to).toLocaleDateString("Fr")]
          }), /*#__PURE__*/_jsx(Table, {
            size: "small",
            columns: cols,
            bordered: true,
            sticky: true,
            loading: isDataLoading,
            dataSource: expensesAr,
            pagination: true
          })]
        }), /*#__PURE__*/_jsxs(Col, {
          children: [/*#__PURE__*/_jsx(AddExpenseCategory, {
            handler: function handler() {
              setDataChanged(true);
              notification.success(_defineProperty({
                message: "Ok!"
              }, "message", "Opération réussie"));
            }
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
            style: {
              padding: "24px",
              background: "#FFFFFF",
              borderRadius: "8px"
            },
            children: [/*#__PURE__*/_jsx("h5", {
              children: "Cat\xE9gories de d\xE9penses"
            }), /*#__PURE__*/_jsx(List, {
              itemLayout: "horizontal",
              dataSource: expenseCategories,
              renderItem: function renderItem(item, index) {
                return /*#__PURE__*/_jsx(List.Item, {
                  extra: [/*#__PURE__*/_jsx(Button, {
                    onClick: function onClick() {
                      setSelectedCategory(item);
                      setShowEditCategory(true);
                    },
                    type: "default",
                    children: /*#__PURE__*/_jsx(PencilSquare, {
                      size: 18
                    })
                  })],
                  children: /*#__PURE__*/_jsx(List.Item.Meta, {
                    title: /*#__PURE__*/_jsx("b", {
                      children: item.label
                    })
                  })
                });
              }
            })]
          })]
        })]
      })
    }), selectedCategory && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsxs("b", {
          children: ["Modifier la cat\xE9gorie - ", selectedCategory.label]
        }),
        width: {
          xs: '85%',
          sm: '60%',
          md: '40%',
          lg: '30%',
          xl: '20%',
          xxl: '20%'
        },
        open: showEditCategory,
        onCancel: function onCancel() {
          setSelectedCategory(true);
        },
        footer: null,
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(EditExpenseCategory, {
          expense_category: selectedCategory,
          handler: function handler() {
            setDataChanged(true);
            setShowEditCategory(false);
            notification.success({
              message: "ok",
              description: "Opération réussie"
            });
          }
        })
      })
    })]
  });
};

export default Expenses;